export default {"src":"/_next/static/media/down-distance-icon.4e1c54e9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};